













































































































































import {Vue, Component, PropSync} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings} from "wings-ui-components";
import {ApnsType} from "@/store/push/application/types";
import {isEmpty} from "lodash";

@Component({
  components: {SelectWings, proxySettingsForm}
})
export default class ApnsSettings extends Vue {
  @PropSync('apnsOptions') apns!: ApnsType;
  @PropSync('filesOptions') files!: { file: File, type: string }[];
  private serverTypeList: string[] = ['PRODUCTION', 'DEVELOPMENT']

  get isAPNSProxy(): boolean {
    return !isEmpty(this.apns.proxy_settings);
  }

  set isAPNSProxy(value: boolean) {
    if (value) {
      this.$set(this.apns, 'proxy_settings', { host: null });
    } else {
      this.$delete(this.apns, 'proxy_settings');
    }
  }

  onFilePicked(file: File, type?: string | null) {
    if (!type) return;
    this.files?.push({file: file, type: type});
    if (type === 'p8') {
      this.apns.key_id = null;
    } else {
      this.apns.passphrase = null;
    }
  }
}
